const uz = {
  common: {
    save: 'Saqlash', saveChanges: "O'zgarishlarni saqlash", cancel: 'Bekor qilish', delete: "O'chirish",
    edit: 'Tahrirlash', add: "Qo'shish", remove: "O'chirish", close: 'Yopish', back: 'Orqaga',
    retry: 'Qayta urinish', loading: 'Yuklanmoqda…', search: 'Qidirish', all: 'Barchasi',
    status: 'Holat', actions: 'Amallar', name: 'Ism', email: 'Email', phone: 'Telefon',
    role: 'Rol', date: 'Sana', joined: "Qo'shilgan", active: 'Faol', inactive: 'Nofaol',
    banned: 'Bloklangan', yes: 'Ha', no: "Yo'q", showing: "Ko'rsatilmoqda", of: 'dan',
    somethingWrong: 'Nimadir xato ketdi', noResults: 'Natija topilmadi', clear: 'Tozalash',
    unknown: "Noma'lum",
  },
  nav: {
    main: 'Asosiy', admin: 'Administratsiya',
    home: 'Bosh sahifa', courses: 'Kurslar', students: "O'quvchilar", clients: 'Mijozlar', sales: 'Sotuvlar',
    leads: 'Lidlar', reminders: 'Eslatmalar', promocodes: 'Promokodlar', inbox: 'Xabarlar', analytics: 'Tahlil',
    calendar: 'Kalendar', team: 'Jamoa', teams: 'Jamoalar', settings: 'Sozlamalar', logout: 'Chiqish',
    account: 'Hisob', workspace: 'Ish maydoni', operations: 'Operatsiyalar', insights: 'Tahlil', collapse: "Menyuni yig'ish", expand: 'Menyuni yoyish', openMenu: 'Navigatsiyani ochish', aiProposals: "AI takliflari ko'rib chiqilishi kerak bo'lgan kurslar: {count}",
  },
  topbar: {
    language: 'Til', notifications: 'Bildirishnomalar', profile: 'Profil',
    signOut: 'Chiqish', theme: 'Mavzu', newCourse: 'Yangi kurs', noNotifications: 'Bildirishnomalar yo\'q',
    eyebrow: {
      workspace: 'Ish maydoni', courses: 'Kurslar', catalog: 'Katalog', people: 'Odamlar',
      commerce: 'Savdo', communication: 'Muloqot', insights: 'Tahlil',
      planning: 'Rejalashtirish', account: 'Hisob',
    },
    title: {
      home: 'Bosh sahifa', createCourse: 'Kurs yaratish', courseWorkspace: 'Kurs boshqaruvi',
      courses: 'Kurslar', students: "O'quvchilar", clients: 'Mijozlar', sales: 'Sotuvlar', inbox: 'Xabarlar',
      analytics: 'Tahlil', calendar: 'Kalendar', team: 'Jamoa', settings: 'Sozlamalar',
      studentDetail: "O'quvchi tafsiloti", profile: 'Profil', quizFeedback: 'Test tahlili', clientDetail: 'Mijoz', mentors: 'Mentorlar',
    },
  },
  students: {
    title: "O'quvchilar", subtitle: "Kurs bo'yicha ro'yxat va progress",
    selectCourse: 'Kursni tanlang…', searchPlaceholder: 'Ism, email yoki telefon bo\'yicha qidirish',
    pickTitle: 'Boshlash uchun kursni tanlang',
    pickDesc: "Yuqoridagi kurslaringizdan birini tanlang — o'quvchilar, ularning progressi va holatini ko'ring.",
    emptyTitle: "Hali o'quvchilar yozilmagan",
    emptyDesc: "O'quvchilar ushbu kursga yozilgach, bu yerda paydo bo'ladi.",
    totalEnrolled: 'Jami yozilgan', avgProgress: "O'rtacha progress", completed: 'Tugatgan', inProgress: 'Jarayonda',
    filterAll: 'Barchasi', filterInProgress: 'Jarayonda', filterCompleted: 'Tugatgan', filterNotStarted: 'Boshlanmagan', filterInactive: 'Kirish yopilgan',
    statusCompleted: 'Tugatgan', statusInProgress: 'Jarayonda', statusNotStarted: 'Boshlanmagan', statusInactive: 'Kirish yopilgan',
    colStudent: "O'quvchi", colProgress: 'Progress', colStatus: 'Holat', colEnrolled: 'Yozilgan', colCompleted: 'Tugatgan',
    noMatch: "Ushbu filtrga mos o'quvchi yo'q.", showingStudents: "o'quvchi",
    rosterCapped: "Faqat birinchi {loaded} ta o'quvchi ({total} tadan) yuklangan; hisoblagichlar va qidiruv faqat shularni qamrab oladi.",
    colGroups: 'Guruhlar', addToGroup: 'Qo\'shish', assignHead: 'Guruhga qo\'shish', inAllGroups: 'Barcha guruhlarda mavjud', allGroups: 'Barcha guruhlar',
    rosterEyebrow: "O'quvchilar ro'yxati", rosterCount: "{count} o'quvchi yozilgan",
    addedToGroup: '{group} guruhiga qo\'shildi', addGroupFailed: 'Guruhga qo\'shib bo\'lmadi',
    noGroupsYet: 'Hali guruhlar yo\'q — «Jamoalar» sahifasida yarating.',
    view: 'Ko\'rish', viewDetail: "O'quvchi tafsilotlari", detailClose: 'Yopish', detailLoadFail: "O'quvchi ma'lumotlarini yuklab bo'lmadi",
    backToRoster: "O'quvchilar ro'yxatiga", detailStudent: "O'quvchi", detailCompletedOn: 'Tugatilgan {date}',
    detailOverall: 'Umumiy progress', detailLessons: 'Darslar tugallandi', detailAvgQuiz: 'O\'rtacha test bali', detailEnrolled: 'Yozilgan',
    detailLessonsSection: 'Darslar progressi', detailQuizzes: 'Test urinishlari', detailActivity: 'So\'nggi faollik',
    detailNoLessons: 'Hozircha dars faoliyati yo\'q.', detailCorrect: '{correct}/{total} to\'g\'ri',
    lessonN: '{n}-dars', quizN: '{n}-test',
    loading: "O'quvchilar yuklanmoqda…", tabAllStudents: "Barcha o'quvchilar", tabAtRisk: 'Xavf ostida',
  },
  orders: {
    title: 'Buyurtmalar', subtitle: "Kurslaringiz bo'yicha to'lovlar va buyurtmalar tarixi",
    searchPlaceholder: 'Mijoz yoki kurs bo\'yicha qidirish',
    emptyTitle: 'Hali buyurtmalar yo\'q', emptyDesc: "O'quvchilar kurslaringizni sotib olgach, buyurtmalar bu yerda paydo bo'ladi.",
    totalRevenue: 'Umumiy daromad', ordersCount: 'Buyurtmalar', completed: 'Tugallangan', avgOrder: "O'rtacha chek",
    colCustomer: 'Mijoz', colCourse: 'Kurs', colAmount: 'Summa', colStatus: 'Holat', colDate: 'Sana',
    noMatch: 'Ushbu filtrga mos buyurtma yo\'q.', showingOrders: 'buyurtma', loading: 'Buyurtmalar yuklanmoqda…',
  },
  discounts: {
    title: 'Chegirmalar',
  },
  feedback: {
    title: 'Fikrlar', subtitle: "O'quvchilardan kurs sharhlari va baholari",
    emptyTitle: 'Hali fikrlar yo\'q', emptyDesc: "O'quvchilar kurslaringizga fikr qoldirgach, bu yerda paydo bo'ladi.",
    all: 'Barchasi', outOf5: '5 dan {value}',
  },
  team: {
    eyebrow: 'Tashkilot', hubSubtitle: "Xodimlar hisoblarini boshqaring va ularni call-markaz, savdo va nazorat jamoalariga bo'ling.", tabPeople: 'Xodimlar', tabTeams: 'Jamoalar',
    title: 'Jamoa', memberCount: 'Hisobingizda {count} a\'zo', memberCountOne: 'Hisobingizda 1 a\'zo',
    addMember: "Qo'shish", addTeamMember: "A'zo qo'shish", editMember: "A'zoni tahrirlash",
    total: 'Jami', admins: 'Adminlar', teachers: "O'qituvchilar", students: "O'quvchilar",
    searchPlaceholder: 'Ism yoki email bo\'yicha qidirish…',
    roleAll: 'Barchasi', roleAdmin: 'Admin', roleTeacher: "O'qituvchi", roleStudent: "O'quvchi",
    sortNewest: 'Avval yangilari', sortOldest: 'Avval eskilari', sortNameAsc: 'Ism A–Z', sortNameDesc: 'Ism Z–A',
    colMember: "A'zo", colContact: 'Aloqa', colRole: 'Rol', colStatus: 'Holat', colJoined: "Qo'shilgan", colActions: 'Amallar',
    fullName: "To'liq ism", password: 'Parol', newPassword: 'Yangi parol',
    passwordHint: 'Joriy parolni saqlash uchun bo\'sh qoldiring', statusActive: 'Faol', statusInactive: 'Nofaol',
    ban: 'Bloklash', unban: 'Blokdan chiqarish', emptyTitle: "A'zolar topilmadi", emptyDesc: "Filtrlarni o'zgartiring yoki yangi a'zo qo'shing",
    removeTitle: "A'zoni o'chirish?", removeMsg: '"{name}" hisobingizdan butunlay o\'chiriladi.',
    banTitle: "A'zoni bloklash?", banMsg: '"{name}" bloklanadi va hisobga kirish huquqini yo\'qotadi.',
    unbanTitle: "A'zoni blokdan chiqarish?", unbanMsg: '"{name}" hisobga kirish huquqini qayta oladi.',
    sort: 'Saralash', changeRole: "Rolni o'zgartirish", viewGrid: 'Katak', viewTable: 'Jadval',
    namePlaceholder: 'Anvar Aliyev', emailPlaceholder: 'user@example.com', phonePlaceholder: '+998901234567',
    passwordPlaceholder: 'Kamida 6 ta belgi', saving: 'Saqlanmoqda…',
    nameRequired: 'Ism kiritilishi shart', passwordRequired: "Yangi a'zolar uchun parol talab qilinadi",
    failedToSave: "Saqlab bo'lmadi", failedToLoad: "Jamoani yuklab bo'lmadi",
    failedToUpdateRole: "Rolni yangilab bo'lmadi", failedToDelete: "A'zoni o'chirib bo'lmadi",
    failedToUpdateBan: "Blok holatini yangilab bo'lmadi",
    roleChanged: "{name} roli {role} ga o'zgartirildi", removedToast: "{name} o'chirildi",
    bannedToast: '{name} bloklandi', unbannedToast: '{name} blokdan chiqarildi',
    memberUpdated: "A'zo yangilandi", memberAdded: "A'zo qo'shildi",
    showingRange: "{from}–{to} / {total} ko'rsatilmoqda",
  },
  settings: {
    title: 'Sozlamalar', subtitle: 'Profil, hisob va sozlamalarni boshqaring',
    navProfile: 'Profil', navAccount: 'Hisob', navPassword: 'Parol', navSession: 'Sessiya',
    profileTitle: 'Profil', profileDesc: "Bu ma'lumot o'quvchilar va jamoa a'zolariga ko'rinadi.",
    yourName: 'Ismingiz', fullName: "To'liq ism", fullNamePlaceholder: "To'liq ismingiz",
    subjectArea: 'Fan yo\'nalishi', selectSubject: 'Fanni tanlang',
    bio: 'Bio', bioPlaceholder: "O'quvchilarga o'zingiz, tajribangiz va o'qitish uslubingiz haqida gapiring",
    uploadPhoto: 'Rasm yuklash', avatarAlt: 'Avatar',
    accountTitle: 'Hisob', accountDesc: "Kirish ma'lumotlaringiz va hisob tafsilotlari.",
    accountId: 'Hisob ID',
    passwordTitle: 'Parolni o\'zgartirish', passwordDesc: "Boshqa joyda ishlatmaydigan kuchli paroldan foydalaning.",
    currentPassword: 'Joriy parol', newPassword: 'Yangi parol', confirmPassword: 'Yangi parolni tasdiqlang',
    currentPasswordPlaceholder: 'Joriy parolni kiriting', newPasswordPlaceholder: 'Kamida 6 ta belgi',
    confirmPasswordPlaceholder: 'Yangi parolni qayta kiriting',
    updatePassword: 'Parolni yangilash',
    pwMinLength: "Parol kamida 6 ta belgidan iborat bo'lishi kerak", pwMismatch: 'Parollar mos kelmadi',
    pwNotAvailable: 'Parolni o\'zgartirish hozircha mavjud emas',
    sessionTitle: 'Sessiya', signOut: 'Chiqish', signOutDesc: 'Ushbu qurilmadagi sessiyani tugatish.',
    signOutQ: 'Chiqasizmi?', signOutConfirm: 'Qayta kirishingiz kerak bo\'ladi. Saqlanmagan o\'zgarishlar yo\'qoladi.',
    saved: 'Profil saqlandi', saving: 'Saqlanmoqda…',
    nameRequired: 'Ism kiritilishi shart', loadFailed: 'Profilni yuklab bo\'lmadi', saveFailed: 'Saqlab bo\'lmadi',
    loadingSettings: 'Sozlamalar yuklanmoqda…',
    subjects: {
      mathematics: 'Matematika', english: 'Ingliz tili', science: 'Tabiiy fanlar', history: 'Tarix',
      languages: 'Tillar', technology: 'Texnologiya', arts: "San'at", other: 'Boshqa',
    },
  },
  calendar: {
    today: 'Bugun', month: 'Oy', week: 'Hafta', newEvent: 'Yangi tadbir',
    categories: 'Kategoriyalar', allEvents: 'Barcha tadbirlar', addCategory: 'Kategoriya qo\'shish',
    pinned: 'Mahkamlangan', loading: 'Kalendar yuklanmoqda…',
    newEventTitle: 'Yangi tadbir', editEventTitle: 'Tadbirni tahrirlash', newCategory: 'Yangi kategoriya', editCategory: 'Kategoriyani tahrirlash',
    fName: 'Nomi', fTitle: 'Sarlavha', fDate: 'Sana', fTime: 'Vaqt', fDescription: 'Tavsif', fCategory: 'Kategoriya',
    fColor: 'Rang', fIcon: 'Ikona', noCategory: '— Kategoriyasiz —', pinEvent: 'Tadbirni tepaga mahkamlash',
    create: 'Yaratish', update: 'Yangilash',
    placeholderCategoryName: 'masalan, Matematika', placeholderEventTitle: 'Tadbir nomi',
    placeholderEventTime: '10:00 - 12:00', placeholderDescription: 'Ixtiyoriy izohlar…',
    saving: 'Saqlanmoqda…', moreEvents: '+{count} yana', previous: 'Oldingi', next: 'Keyingi',
    failedToLoad: 'Kalendar ma\'lumotlarini yuklab bo\'lmadi', failedToSaveEvent: 'Tadbirni saqlab bo\'lmadi',
    failedToDeleteEvent: 'Tadbirni o\'chirib bo\'lmadi', failedToSaveCategory: 'Kategoriyani saqlab bo\'lmadi',
    failedToDeleteCategory: 'Kategoriyani o\'chirib bo\'lmadi',
    confirmDeleteEvent: 'Bu tadbirni o\'chirasizmi?',
    confirmDeleteCategory: 'Bu kategoriyani o\'chirasizmi? Tadbirlar kategoriyasiz qoladi.',
  },
};

export default uz;
